import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';
import { Form as FinalForm, Field } from 'react-final-form';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { Form, Button, ToggleSwitch } from '../../components';

import css from './AccountVisibilityForm.css';

const AccountVisibilityFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      const {
        rootClassName,
        className,
        handleSubmit,
        intl,
        inProgress,
        ready,
        initialValues,
        values,
        saveError,
      } = formRenderProps;

      const classes = classNames(rootClassName || css.root, className);
      const pristineToInitial = isEqual(values, initialValues);
      const submitDisabled = inProgress || pristineToInitial;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <p className={css.description}>
            <FormattedMessage id="AccountSettingsPage.visibilityDescription" />
          </p>

          <div className={css.toggleRow}>
            <Field name="hideProfile" type="checkbox">
              {({ input }) => (
                <ToggleSwitch
                  isOn={!!input.checked}
                  onToggle={next => input.onChange(next)}
                  label={intl.formatMessage({ id: 'AccountSettingsPage.hideProfileLabel' })}
                />
              )}
            </Field>
          </div>

          {saveError ? (
            <p className={css.error}>
              <FormattedMessage id="AccountSettingsPage.visibilityError" />
            </p>
          ) : null}

          <div className={css.bottomWrapper}>
            <Button
              type="submit"
              className={css.submitButton}
              inProgress={inProgress}
              ready={ready}
              disabled={submitDisabled}
            >
              <FormattedMessage id="AccountSettingsPage.saveChanges" />
            </Button>
          </div>
        </Form>
      );
    }}
  />
);

AccountVisibilityFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  inProgress: false,
  ready: false,
  saveError: null,
};

const { bool, string } = PropTypes;

AccountVisibilityFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  inProgress: bool,
  ready: bool,
  intl: intlShape.isRequired,
  saveError: propTypes.error,
};

const AccountVisibilityForm = injectIntl(AccountVisibilityFormComponent);
AccountVisibilityForm.displayName = 'AccountVisibilityForm';

export default AccountVisibilityForm;
